import { render } from "./packageV2.vue?vue&type=template&id=72ec69ac&scoped=true"
import script from "./packageV2.vue?vue&type=script&lang=js"
export * from "./packageV2.vue?vue&type=script&lang=js"

import "./packageV2.vue?vue&type=style&index=0&id=72ec69ac&lang=less&scoped=true"

import exportComponent from "/Users/zhangmohan/work/activitymarketing-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ec69ac"]])

export default __exports__